import { Alert, Button, Descriptions, Popconfirm, Row } from "antd";
import { StopOutlined, SendOutlined } from '@ant-design/icons';
import { IAttachment } from "../../baseInfo/attachment/interfaces";
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { Core } from "../../components/infrastructure/core";
import { enmEntityState, ICallOptions, IResult } from "../../components/infrastructure/models";
import { DocumnetsUploader } from "./documentsUploader";
import React from "react";

interface IUploadDocumentsStates extends IBaseStates {
    attachments: IAttachment[];
}

export interface IUploadDocumentsProps extends IBaseProps {
    ticketNo: number;
    removeable?: boolean;
    onRemove?: (ticketNo: number) => Promise<void>;
    essentialDocuments?: { Name: string; Code: string; Required?: boolean; }[];
    descriptions?: string;
}

export class UploadDocuments extends BaseComponent<IUploadDocumentsProps, IUploadDocumentsStates>{
    constructor(props: IUploadDocumentsProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
            attachments: (this.props.essentialDocuments ?? []).map(d => {
                return {
                    RowGuid: Core.newId(),
                    CreatorId: 0,
                    State: enmEntityState.Added,
                    Path: undefined,
                    Description: d.Name,
                    DocumentTypeCode: d.Code,
                    Required: d.Required || d.Required === undefined
                } as any;
            })
        };
        this.title = "آپلود مدارک";
    }
    componentDidMount() {
        super.componentDidMount();
        this.setLoading(false);
    }
    onChangeAttachments = (attachments: IAttachment[]) => {
        this.setState({ attachments });
    }
    submit = async () => {
        let notSelectedAttachments: IAttachment[] = [];
        let formData = new FormData();
        formData.append('TicketNo', this.props.ticketNo.toString());
        this.state.attachments.forEach(attachment => {
            if ((attachment as any).File)
                formData.append('Attachments', (attachment as any).File);
            else if ((attachment as any).Required === true)
                notSelectedAttachments.push(attachment);
            else
                return;

            formData.append('Descriptions', attachment.Description!);
            formData.append('DocumentTypeCodes', (attachment as any).DocumentTypeCode);
        });

        if (notSelectedAttachments.length > 0) {
            Core.warningNotification('لطفا همه مدارک اجباری را آپلود نمائید');
            return;
        }

        let opt: ICallOptions = {
            withBlock: true,
            withBlockTitle: 'در حال آپلود مستندات خسارت...',
            url: "portal/uploadessentialdocuments",
            data: formData,
            contentType: false,
            headers: [{ key: "encType", value: "multipart/form-data" }],
            onSuccess: (result: IResult) => {
                if (result.ValidationState.Successful) {
                    Core.successNotification('مستندات با موفقیت آپلود شد و پرونده برای ارزیابی ارسال شد')
                    this.props.onClose && this.props.onClose(this);
                }
            }
        };
        await this.callApi(opt);
    }
    virtualRender() {
        const extraHeaderNodes: React.ReactNode[] = [];
        extraHeaderNodes.push(
            <Descriptions key={"Descriptions"} className="header-page">
                <Descriptions.Item label="شماره پیگیری">{this.props.ticketNo}</Descriptions.Item>
            </Descriptions>
        );

        const header = this.getPageHeader({
            title: this.title,
            onBack: () => { this.props.onClose && this.props.onClose(this); },
            extraHeaderNodes
        });

        return (
            <div>
                {!!this.props.invokePath && header}

                <Alert
                    style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                    message={
                        !this.props.invokePath
                            ?
                            <>
                                <Row>بیمه گزار/مشتری گرامی، خواهشمند است فایلهای مشخص شده زیر، جهت رفع نقص مدارک، مجدد بارگذاری گردد</Row>
                                <Row>
                                    <>توضیحات:</>
                                    <b style={{ marginRight: 10 }}>{this.props.descriptions}</b>
                                </Row>
                            </>
                            :
                            <>

                                بیمه گزار/مشتری گرامی، در صورت عدم آپلود مدارک زیر، پرونده خسارت برای کارشناسان ارزیاب ارسال نخواهد شد.
                                <br />
                                خواهشمند است فایل‌های مشخص شده زیر جهت ارزیابی پرونده خسارت، بارگذاری گردد.
                            </>
                    }
                    type="info"
                    showIcon
                />

                <DocumnetsUploader attachments={this.state.attachments} onChange={this.onChangeAttachments} />

                <div style={{ borderTop: '1px solid #e5e5e5', padding: '5px 45px', marginTop: 10, direction: "ltr" }}>
                    <Button type="primary" htmlType="button" icon={<SendOutlined rotate={180} />} loading={this.state.loading} style={{ width: "150px", marginTop: 10, marginBottom: 10 }} onClick={this.submit}>
                        ارسال مدارک
                    </Button>

                    <Button type="ghost" htmlType="button" loading={this.state.loading} style={{ width: "160px", marginTop: 10, marginBottom: 10, marginLeft: 10, background: '#fff' }} onClick={() => this.props.onClose && this.props.onClose(this)}>
                        بعداً ارسال می نمایم
                    </Button>

                    {this.props.removeable &&
                        <Popconfirm okButtonProps={{ size: "middle" }} cancelButtonProps={{ size: "middle" }} okText="بلی" cancelText="خیر" title="آیا مایلید پرونده خسارت را حذف نمایید؟"
                            onConfirm={async () => {
                                if (this.props.onRemove)
                                    await this.props.onRemove(this.props.ticketNo);
                                this.props.onClose && this.props.onClose(this);
                            }}>
                            <Button type="ghost" htmlType="button" icon={<StopOutlined />} loading={this.state.loading} style={{ width: "170px", marginTop: 10, marginBottom: 10, marginLeft: 10, background: '#fff' }}>
                                حذف پرونده خسارت
                            </Button>
                        </Popconfirm>
                    }
                </div>
            </div>
        );
    }
}